import React from "react";
import { format, parseISO } from "date-fns";
import SessionFlag from "./SessionFlag";
import SessionRowActions from "./SessionRowActions";
import { VenueSession } from "../../app/types";
import breakPoints from "../app/BreakPoints";
import GradientCard from "../common/GradientCard";
import LightTheme from "../theme/LightTheme";

interface Props {
  session: VenueSession;
}

const KeynoteRow = ({ session }: Props) => (
  <GradientCard>
    <div className="row">
      <div className="info">
        <div className="meta">
          <div>
            <SessionFlag sessionId={session.sessionId} />
          </div>
          <div className="dateAndTime">
            <p className="time">
              {format(parseISO(session.startTime), "h:mmaaa")} -{" "}
              {format(parseISO(session.endTime), "h:mmaaa")}
            </p>
            <p className="date">
              {format(parseISO(session.startTime), "eeee, MMMM do")}
            </p>
          </div>
        </div>
        <p className="keynoteBlockTitle">{session.title}</p>
      </div>
      <SessionRowActions sessionId={session.sessionId} />
    </div>
    <style jsx>
      {`
        p {
          padding: 0;
          margin: 0;
        }
        .dateAndTime {
          display: flex;
          justify-content: space-between;
          font-size: 0.8rem;
        }
        .meta {
          display: flex;
          align-items: center;
        }
        .keynoteBlockTitle {
          font-weight: bold;
          font-size: 1.5rem;
          color: #343434;
          margin: 0;
          padding: 10px 0;
        }
        .date {
          color: ${LightTheme.font.secondary.color};
          padding: 0 5px 0 0;
        }
        .time {
          font-weight: bold;
          color: #3a3a3b;
        }
        .row {
          flex-direction: row;
          display: flex;
          padding: 30px;
          border-radius: 10px;
          overflow: hidden;
        }
        .date {
          padding: 0 0 0 5px;
        }
        @media only screen and (max-width: ${breakPoints.small}px) {
          .row {
            flex-direction: column;
          }
          .meta {
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
          }
          .time {
            padding: 0 0 0 5px;
          }
        }
        .info {
          flex-grow: 1;
        }
      `}
    </style>
  </GradientCard>
);

export default KeynoteRow;
